import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class SplashBackground extends Phaser.GameObjects.Container {

    private background1: Phaser.GameObjects.Image;
    private background2: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;
        this.scaleY = GameVars.scaleY;

        this.background1 = new Phaser.GameObjects.Image(this.scene, 0, -140, "bg");
        this.background1.setScale(.5);
        this.add(this.background1);

        this.background2 = new Phaser.GameObjects.Image(this.scene, 0, -140, "bg");
        this.background2.setScale(.5);
        this.background2.alpha = .5;
        this.add(this.background2);

        this.animate();
    }

    private animate(): void {

        const s1 = .55;
        const s2 = .575;

        const t1 = 4000;
        const t2 = 6000;
    
        let chain = this.scene.tweens.chain({
            targets: this.background1,
            tweens: [
                {
                    scaleX: s1,
                    scaleY: s1,
                    ease: Phaser.Math.Easing.Cubic.InOut,
                    duration: t1
                },
                {
                    scaleX: .5,
                    scaleY: .5,
                    ease: Phaser.Math.Easing.Cubic.InOut,
                    duration: t2,
                    onComplete: () => {
                        this.animate();
                    },
                    onCompleteScope: this
                }
            ]
        });
        chain.play();

        chain = this.scene.tweens.chain({
            targets: this.background2,
            tweens: [
                {
                    scaleX: s2,
                    scaleY: s2,
                    ease: Phaser.Math.Easing.Cubic.InOut,
                    duration: t1
                },
                {
                    scaleX: .5,
                    scaleY: .5,
                    ease: Phaser.Math.Easing.Cubic.InOut,
                    duration: t2,
                    onComplete: () => {
                        this.animate();
                    },
                    onCompleteScope: this
                }
            ]
        });
        chain.play();
    }
}
